import React, { FunctionComponent, useMemo } from "react";

import "./_progress-ring.scss";

interface IProgressRingProps {
  radius: number;
  stroke: number;
  progress: number;
}

export const ProgressRing: FunctionComponent<IProgressRingProps> = ({ radius, stroke, progress }) => {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = useMemo(() => circumference - (progress / 100) * circumference, [circumference, progress]);

  return (
    <svg className="progress-ring" height={radius * 2} width={radius * 2}>
      <circle stroke="#CFD6E0" fill="transparent" strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />
      <circle
        stroke="#64738E"
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + " " + circumference}
        style={{ strokeDashoffset }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
};
